export default __webpack_public_path__ + "static/media/Paper_img.7d2a44f8.png";